import Repository from './Repository';

export default class ProductRepository extends Repository {
    protected basePath = 'products';

    protected messages = {
        destroy : this.__('Termék sikeresen törölve.'),
        store : this.__('Termék sikeresen létrehozva.'),
        update : this.__('Termék sikeresen frissítve.'),
    }

    protected redirects = {
        store: { name : 'products' }
    }

    public export(data: object): Promise {
        console.error('Export method does not exist on ProductRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on ProductRepository.');
    }
}